// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  margin: 0 auto;\n  font-family: Verdana,Geneva,sans-serif; }\n\n.container {\n  background: #f6f6ef;\n  max-width: 85%;\n  margin: 0 auto; }\n", ""]);
// Exports
module.exports = exports;
